import { render, staticRenderFns } from "./Iujptl.vue?vue&type=template&id=5894fd7f&"
import script from "./Iujptl.vue?vue&type=script&lang=js&"
export * from "./Iujptl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports